import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Footer as HTMLFooter } from '@expo/html-elements';
import {
  Container,
  HStack,
  theme,
  useContainerSpacing,
  useResponsive,
} from '@sg/garnish';

import { useOrganizationLinksFooterContentfulData } from '@order/hooks';

import {
  OrganizationLinksFooterCopyright,
  OrganizationLinksFooterSection,
} from './components';

// ────────────────────────────────────────────────────────────────────────────────

export const OrganizationLinksFooter = () => {
  const contentfulFooter = useOrganizationLinksFooterContentfulData();

  const containerSpacing = useContainerSpacing();
  const { currentBreakpoint, minWidth, match } = useResponsive();

  const itemsPerRow = match([1, 2, contentfulFooter.sections.length + 2]);
  const contentStyles = match([undefined, styles.contentMarginSM, undefined]);
  const footerStyles = [styles.footer, { paddingVertical: containerSpacing }];

  return (
    <HTMLFooter style={footerStyles}>
      <Container style={styles.container}>
        <HStack itemsPerRow={itemsPerRow} style={contentStyles}>
          {contentfulFooter.sections.map((section) => (
            <OrganizationLinksFooterSection
              key={section.name}
              section={section}
            />
          ))}

          {minWidth.isMD ? <EmptyColumn /> : null}

          {currentBreakpoint.isSM ? null : <OrganizationLinksFooterCopyright />}
        </HStack>

        {currentBreakpoint.isSM ? <OrganizationLinksFooterCopyright /> : null}
      </Container>
    </HTMLFooter>
  );
};

// ─── Helpers ────────────────────────────────────────────────────────────────────

const EmptyColumn = View; // For Layout with ItemsPerRow.

// ─── Styles ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  footer: {
    marginTop: 'auto',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.SKY,
  },
  container: {
    gap: theme.spacing['8'],
  },
  contentMarginSM: {
    marginRight: '33%',
  },
});
